import React, { useEffect } from 'react';
import Card from '../../../../components/Card/Card';
import { connect } from 'react-redux';
import { Table, UncontrolledCollapse, Col, Container, Row } from 'reactstrap';
import { startSetWallets } from '../../../../actions/wallets';
import { FMessage } from '../../../../hoc/IntlComponents';
import WithProfileNav from '../../hoc/withProfileNav';

const ProfileInfoPage = ({ profile, wallets, startSetWallets, history }) => {
  const getAccounts = _ => ({
    telegram: profile.accounts.find(({ title }) => title === 'Telegram').login,
    vk: profile.accounts.find(({ title }) => title === 'vk.com').login,
    facebook: profile.accounts.find(({ title }) => title === 'Facebook').login,
    searchengines: profile.accounts.find(({ title }) => title === 'searchengines').login,
    kote: profile.accounts.find(({ title }) => title === 'kote.ws').login,
    webmasters: profile.accounts.find(({ title }) => title === 'webmasters.ru').login,
  });

  const getWalletType = () =>
    wallets &&
    wallets.map(({ title, wallets, type }) => ({
      type,
      title,
      wallets,
    }));

  useEffect(() => {
    async function getWallets() {
      await startSetWallets();
    }
    getWallets();
  }, []);

  const renderWalletsCollapse = (wallets, id) => {
    return wallets.map(({ title, wallets, type }, id) =>
      wallets.length > 0 ? (
        <tr key={type}>
          <td className="text-right pr-0 font-weight-bold">
            {id === 0 && <FMessage id={`profile.info.wallets`} />}
          </td>
          <td>
            <span className="dropdown-toggle btn no-padding" id={`toggler${type}`}>
              {title}
            </span>
            <UncontrolledCollapse toggler={`toggler${type}`}>
              {wallets.map(({ number }) => (
                <div className="py-2" key={number}>
                  {number}
                </div>
              ))}
            </UncontrolledCollapse>
          </td>
        </tr>
      ) : null,
    );
  };

  const filteredProfile = {
    email: profile.email,
    name: profile.name,
    phone: profile.phone,
    icq: profile.icq,
    skype: profile.skype,
    ...getAccounts(),
    api: profile.api_key,
    wallets: getWalletType(),
  };
  return (
    <Card>
      <Card.Body className="no-padding">
        {profile && wallets && (
          <Table bordered responsive className="no-margin">
            <tbody>
              {Object.keys(filteredProfile).map(title => {
                return title !== 'wallets' ? (
                  <tr key={title}>
                    <td className="text-right pr-0 font-weight-bold">
                      <FMessage id={`profile.info.${title}`} />
                    </td>
                    <td>{filteredProfile[title]}</td>
                  </tr>
                ) : (
                  renderWalletsCollapse(filteredProfile[title])
                );
              })}
            </tbody>
          </Table>
        )}
      </Card.Body>
    </Card>
  );
};

const mapStateToProps = ({ webmaster: { profile, wallets } }) => ({ profile, wallets });

const mapDispatchToProps = {
  startSetWallets,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(WithProfileNav(ProfileInfoPage));
